import { ClientFile } from "@/shared";
import { Box, Typography } from "@mui/material";
import React from "react";
import { File } from "./File";
import { match } from "ts-pattern";
import FolderOffIcon from "@mui/icons-material/FolderOff";

interface ClientFilesListProps {
  clientFiles: ClientFile[];
  error: Error | null;
}

export const ClientFilesList = ({
  clientFiles,
  error,
}: ClientFilesListProps) => {
  return (
    <>
      {match({ isEmpty: !clientFiles.length || error })
        .with({ isEmpty: true }, () => (
          <Box
            sx={{
              width: "100%",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <FolderOffIcon sx={{ width: 80, height: 80 }} />
            <Typography sx={{ fontSize: 18, fontStyle: "italic" }}>
              Файлів не знайдено
            </Typography>
          </Box>
        ))
        .otherwise(() => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 6,
              flexWrap: "wrap",
              padding: 4,
            }}
          >
            {clientFiles.map((file, index) => (
              <Box key={index}>
                <File file={file} />
              </Box>
            ))}
          </Box>
        ))}
    </>
  );
};
